import type { AiAppCenterModule } from '../types'

export const rentalModule: AiAppCenterModule = {
  key: 'rental',
  label: '产品租赁',
  desc: '概况 / 商品 / 交易 / 首页运营 / 营销 / 商家客服',
  path: '/rental',
  homePath: '/rental/overview',
  icon: 'ep:shopping-bag',
  color: '#0d9488',
  aliases: ['租赁', 'AI产品租赁', '商品租赁']
}
